module.exports = __webpack_public_path__ + "img/svg/step2.7ab433a3a05b4a22e7d9b135281a6fa1.svg";